import React, { useCallback, useState } from "react";
import MobileTabBar from "./index";
import InboxSheet from "./InboxSheet";

const MobileAppNav = ({ items, tone, inbox = null }) => {
  const [inboxOpen, setInboxOpen] = useState(false);
  const closeInbox = useCallback(() => setInboxOpen(false), []);

  const withInbox = items.map((item) =>
    item.key === "inbox" && inbox
      ? {
          ...item,
          badge: inbox.countsKnown === false ? 0 : (inbox.unreadIntroductions || 0) + (inbox.unreadMessages || 0),
          isActive: inboxOpen,
          reopen: true,
          onClick: () => {
            inbox.onOpen?.();
            setInboxOpen(true);
          },
        }
      : item,
  );

  return (
    <>
      <MobileTabBar items={withInbox} tone={tone} />
      {inboxOpen && inbox ? (
        <InboxSheet
          unreadMessages={inbox.unreadMessages || 0}
          showMessages={inbox.showMessages !== false}
          onOpenMessages={inbox.onOpenMessages}
          introductions={inbox.introductions}
          onClose={closeInbox}
        />
      ) : null}
    </>
  );
};

export default MobileAppNav;
